import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_ENTITYCARD_REGISTRY_KEY, META_TYPE, META_VER } from './entityCardCommandRegisteryType';

/**
 * Registers the /card command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /card <rk> — opens/refocuses an EntityCard for that rk (multi-instance, target=rk),
 * e.g. /card eco-01, /card near-balance, /card zendure.
 */
export function registerCardCommand() {
    commandEngine.register('/card', {
        hint: '<rk> — open entity card, e.g. /card eco-01',
        params: [{ name: 'rk' }],
        handler: ([rk]) => {
            if (!rk) return;

            cardPainterManager.openCard(CMD_ENTITYCARD_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: rk }, { rk });
        },
    });
}
